import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const PeopleHeader = ({ reloadCompanyMemberList = () => {} }) => {
  const breadCrumbText = [
    { title: "Company", link: "/admin/companies" },
    { title: "People" },
  ];

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          {/* -------- bread crumb ------------ */}
          <BreadCrumb breadCrumbText={breadCrumbText} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadCompanyMemberList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title="Reload"
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">Reload</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PeopleHeader;
